// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pN2u","colMin":"styles_colMin__2zKLj"};